import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, IconButton, Skeleton, Stack, Typography, colors } from '@mui/material';
import parse, { DOMNode } from 'html-react-parser';
import { useSearchContext } from '../context';
import { Download } from '@mui/icons-material';
import { ContentPage } from '../styles';
import { DraftPreface } from 'views/App/Portal/Policy/_types/manuals/draft';

function DraftManualsSearchPreface({
  manualId,
  preface,
  scrollId,
}: {
  manualId: string;
  preface?: DraftPreface;
  scrollId?: string;
}) {
  const [params] = useSearchParams();
  const { handleDownload, isContentLoading } = useSearchContext();

  useEffect(() => {
    if (scrollId) {
      const element = document.getElementById(`preface_${scrollId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [scrollId, isContentLoading]);

  if (!preface) {
    return (
      <ContentPage>
        <Stack spacing={2}>
          <Skeleton
            variant='text'
            width='60%'
            height={32}
          />
          <Skeleton
            variant='text'
            width='40%'
            height={24}
          />
          <Skeleton
            variant='rectangular'
            height={200}
          />
        </Stack>
      </ContentPage>
    );
  }

  return (
    <ContentPage>
      <Stack spacing={3}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Stack spacing={1}>
            <Typography variant='h5'>{preface.title}</Typography>
            <Typography
              variant='body2'
              color='text.secondary'
            >
              {preface.updatedAt && `Last Updated: ${preface.updatedAt}`}
            </Typography>
          </Stack>
          {/* TODO: Add download button
          <IconButton
            onClick={() => handleDownload(manualId, preface.id, 'PREFACE', preface.title)}
            sx={{ color: 'primary.main' }}
          >
            <Download />
          </IconButton> */}
        </Box>

        <Box
          id={`preface_${preface.id}`}
          sx={{
            backgroundColor: scrollId === preface.id ? 'rgba(255, 193, 7, 0.1)' : 'transparent',
            p: 2,
            borderRadius: 1,
            border: scrollId === preface.id ? '2px solid rgba(255, 193, 7, 0.3)' : 'none',
          }}
        >
          <Box sx={{ '& p': { mb: 2 } }}>
            {parse(preface.content, {
              replace: (domNode: DOMNode) => {
                if (domNode.type === 'tag' && domNode.name === 'span' && domNode.attribs?.class === 'text-entity') {
                  return (
                    <span
                      key={Math.random()}
                      className='text-entity'
                      style={{
                        padding: '2px 4px',
                        borderRadius: 8,
                        display: 'inline-flex',
                      }}
                    >
                      {domNode.children?.[0] && 'data' in domNode.children[0] ? (domNode.children[0] as any).data : ''}
                    </span>
                  );
                }
              },
            })}
          </Box>
        </Box>
      </Stack>
    </ContentPage>
  );
}

export default DraftManualsSearchPreface;
